// extracted by mini-css-extract-plugin
export default {"medicine-wise-stock-request-report-container":"MedicineWiseStockRequestReport_medicine-wise-stock-request-report-container__wLPKM"};